import { PigIcon } from './PigIcon';

/**
 * author: Austin Andrews
 * id 5E4A3F96-7779-44C8-86EF-948EDBD53C20
 * name pig
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pig.svg
 * tags
 * - Animal 
 * - Agriculture 
 */
export const EmoticonPigIcon = PigIcon;
export default EmoticonPigIcon